import i18n from "i18n";
import { action, observable } from "mobx";

import { ToastMethods } from "components/ToastNotification";
import type { School, SchoolType } from "models/auth/Login";
import { profileRepository } from "repositories";

interface ErrorResponse {
  status: number;
  message: string;
  type: string;
}

interface LoginInterface {
  loading: boolean;
  schoolList: School[];
  updateUserInfoLoginSucceed: boolean;
  getSchoolList: (schoolType?: SchoolType) => void;
  setLoading: (loading: boolean) => void;
  setSchoolList: (schools: School[]) => void;
  setUpdateUserInfoLoginSucceed: (succeed: boolean) => void;
  updateUserInfoLogin: (educationId: string, studentId: string) => void;
}
const initialState = {
  loading: false,
};

const stateSetters = {
  setLoading: action((loading: boolean) => {
    store.loading = loading;
  }),
  setSchoolList: action((schools: School[]) => {
    store.schoolList = schools;
  }),
  setUpdateUserInfoLoginSucceed: action((succeed: boolean) => {
    store.updateUserInfoLoginSucceed = succeed;
  }),
};

const apiRequests = {
  getSchoolList: action((schoolType?: SchoolType) => {
    store.setLoading(true);
    profileRepository
      .getSchoolList(schoolType)
      .then((schools: School[]) => {
        store.setSchoolList(schools);
      })
      .catch(() => {
        ToastMethods.showToast(i18n.t("toast:profile.getschoolList.error"), "error");
      })
      .finally(() => {
        store.setLoading(false);
      });
  }),
  updateUserInfoLogin: action((educationId: string, studentId: string) => {
    profileRepository
      .updateUserEducation(educationId, studentId)
      .then(() => {
        store.setUpdateUserInfoLoginSucceed(true);
      })
      .catch((error: ErrorResponse) => {
        store.setUpdateUserInfoLoginSucceed(false);
        if (error.status === 409) {
          ToastMethods.showToast(i18n.t("toast:profile.userAlreadyRegistered.error"), "error");
        } else {
          ToastMethods.showToast(i18n.t("toast:profile.updateUserInfoLogin.error"), "error");
        }
      });
  }),
};

const store = observable({
  ...initialState,
  ...stateSetters,
  ...apiRequests,
} as LoginInterface);

export const useLogin = (): LoginInterface => store;
